import {
  IUserData,
  IUserAddress,
  IUserCard,
  IUserInfo,
  IUserPayload,
  IDevice,
} from '../types/paymentLinkContextTypes';

const useFormatPayload = () => {
  const formatPersonalData = (userData: IUserInfo): IUserData => {
    return {
      name: userData.name,
      cpf: userData.cpf,
      email: userData.email,
      birth_date: userData.birth_date,
      phone: userData.phone.replace(/[()-]/g, '').replace(/\s/g, ''),
    };
  };

  const formatAddressData = (userData: IUserInfo): IUserAddress => {
    return {
      state: userData.state,
      city: userData.city,
      district: userData.city,
      complement: userData.complement,
      number: userData.number,
      street: userData.street,
      cep: userData.cep.replace('-', ''),
    };
  };

  const formatPaymentData = (userData: IUserInfo): IUserCard => {
    return {
      card_number: userData.card_number.replace(/\s/g, ''),
      card_valid_date: userData.card_valid_date,
      card_client_name: userData.card_client_name,
      card_cvv: userData.card_cvv,
      installments: userData.installments,
    };
  };

  const formatDeviceData = (): IDevice => {
    return {
      type: 'BROWSER',
      java_enabled: true,
      color_depth: screen.colorDepth.toString(),
      screen_height: screen.height.toString(),
      screen_width: screen.width.toString(),
      time_zone_offset: '3',
    };
  };

  const getFormatedPayload = (userData: IUserInfo): IUserPayload => {
    const personal = formatPersonalData(userData);
    const address = formatAddressData(userData);
    const payment = formatPaymentData(userData);
    const device = formatDeviceData();

    const payload: IUserPayload = {
      ...personal,
      address,
      payment,
      device,
    };

    return payload;
  };

  return { getFormatedPayload };
};

export default useFormatPayload;
